import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { useViewer } from '@/features/session';
import { firstUserErrorCode } from '@/graphql/errors';
import { UPDATE_BILLING_EMAIL } from '@/graphql/mutations/billing';

type UseUpdateBillingEmailResult = {
  updateBillingEmail: (email: string) => Promise<{ errorCode: string | null }>;
};

export function useUpdateBillingEmail(): UseUpdateBillingEmailResult {
  const { refreshViewer } = useViewer();
  const [mutate] = useMutation(UPDATE_BILLING_EMAIL);

  const updateBillingEmail = useCallback(
    async (email: string) => {
      const { data } = await mutate({ variables: { input: { email } } });
      const errorCode = firstUserErrorCode(data?.updateBillingEmail.userErrors);
      if (!errorCode) await refreshViewer();
      return { errorCode };
    },
    [mutate, refreshViewer],
  );

  return { updateBillingEmail };
}
